import { Detection, FieldValue } from 'src/data-capture/types';
import { detectionSavesOwners } from './cashflowDetections';

export const JOINT_FIELD = 'is_joint';

/**
 * A detection that carries owners has its joint answer settled by the owners editor's switch, so
 * the document's answer is not also offered as a field of its own: two controls for one fact
 * could save an item joint with the switch showing it sole. This is decided once, as the
 * detection loads, and kept on its review state as `jointDecidedBySwitch`: owners edited at review
 * give the detection a `resolvedOwners` it may not have arrived with, and must not move the joint
 * answer from a field to the switch part way through.
 */
export const ownersEditorDecidesJoint = (detection: Detection): boolean =>
  detection.resolvedOwners != null && detectionSavesOwners(detection.entity.entityType);

/**
 * Takes the document's joint answer out of the detected fields, keeping it beside them as the
 * switch's starting point. Each conflict still lists it among the fields that differ, so a
 * document that disagrees with a record only about joint-ness still has a card to review.
 */
export function takeJointAnswer(detection: Detection): {
  detection: Detection;
  detectedJoint?: FieldValue;
} {
  const { [JOINT_FIELD]: detectedJoint, ...fields } = detection.entity.fields;
  return {
    detectedJoint,
    detection: { ...detection, entity: { ...detection.entity, fields } },
  };
}
